import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

export const DESCRIPTOR_REQUEST_FUNCTIONS = {
  list: 'callableReviewListDescriptorRequests-listDescriptorRequests',
  approve: 'callableReviewApproveDescriptorRequest-approveDescriptorRequest',
  decline: 'callableReviewDeclineDescriptorRequest-declineDescriptorRequest',
};

function callDescriptorFunction(name, payload) {
  return httpsCallable(functions, name)(payload);
}

export async function listDescriptorRequests() {
  const result = await callDescriptorFunction(DESCRIPTOR_REQUEST_FUNCTIONS.list, {});
  const requests = result?.data?.requests;
  return Array.isArray(requests) ? requests : [];
}

export async function approveDescriptorRequest({
  requestId,
  approvedLabel,
  approvedCategory,
}) {
  const result = await callDescriptorFunction(DESCRIPTOR_REQUEST_FUNCTIONS.approve, {
    requestId,
    approvedLabel,
    approvedCategory,
  });
  return result.data;
}

export async function declineDescriptorRequest(requestId) {
  const result = await callDescriptorFunction(DESCRIPTOR_REQUEST_FUNCTIONS.decline, {
    requestId,
  });
  return result.data;
}
